var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 15.7044V19.3925C4.5 19.9514 4.71071 20.4875 5.08579 20.8827C5.46086 21.278 5.96957 21.5 6.5 21.5H18.5C19.0304 21.5 19.5391 21.278 19.9142 20.8827C20.2893 20.4875 20.5 19.9514 20.5 19.3925V15.7044M12.5007 15.4425L12.5007 3.5M12.5007 3.5L7.92931 8.06318M12.5007 3.5L17.0722 8.06318",
    stroke: "#4B81F4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload03);
export default __webpack_public_path__ + "static/media/upload-03.e1fab464153bf1f5d4bf8312319d7cc3.svg";
export { ForwardRef as ReactComponent };